// extracted by mini-css-extract-plugin
export default {"otab-container":"oTab_otab-container__G4LJd","otab-button":"oTab_otab-button__NF+0m","active":"oTab_active__z3Pib"};